@import "vendors/bootstrap/variables.less";
@import "variables.less";

@import "mixins/hover.less";
@import "mixins/background-variant.less";
@import "mixins/breakpoints.less";
@import "mixins/text-truncate.less";
@import "mixins/text-emphasis.less";
@import "mixins/text-hide.less";
@import "mixins/print.less";

@import "utilities/display.less";
@import "utilities/spacing.less";
@import "utilities/flex.less";
@import "utilities/text.less";
@import "utilities/background.less";
@import "utilities/position.less";
@import "utilities/sizing.less";
@import "utilities/borders.less";
@import "utilities/misc.less";

@import "base.less";
@import "fonts.less";
@import "shared.less";
@import "overrides.less";
@import "utils.less";
@import "pages/opp.less";
@import "pages/priorities.less";
@import "pages/metrics.less";
@import "pages/meetings.less";
@import "pages/review.less";
@import "pages/teamview.less";
@import "actionitem.less";
@import "dropdown.less";
@import "slider.less";
@import "pages/swimlanes.less";
@import "pages/coach-plan.less";
@import "periods.less";
@import "components/lists.less";
@import "components/getting-started.less";
@import "components/select-input.less";
@import "components/page.less";
@import "components/priority.less";
@import "components/page-header-lipstick.less";
@import "components/page-sidenav-lipstick.less";
@import "pages/rolling-forecast.less";
@import "pages/war-room.less";
@import "pages/coach-notes.less";
@import "pages/kpfm.less";
@import "pages/organisation.less";

@media print {
    a[href]:after {
        content: none;
    }

    .no-print,
    .no-print * {
        display: none !important;
    }
}

@media screen {
    .print-only {
        display: none !important;
    }
}

/*******************************************************************
 *
 *
 *  Login Page
 *
 *
 ******************************************************************/

.responsive-input {
    min-width: 250px;
    max-width: 400px;
    width: 100%;
}

/*******************************************************************
 *
 *
 *  Admin Organization Page
 *
 *
 ******************************************************************/
ul.orgList {
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 0px;
}
li.orgListItem {
    font-size: 15px;
    margin: 0px;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 3px;
    border-bottom: 1px solid #c8c8c8;
}
li.orgListItem:last-child {
    border: none;
}
li.orgListItem a {
    display: block;
    -webkit-transition:
        font-size 0.2s ease,
        background-color 0.2s ease;
    -moz-transition:
        font-size 0.2s ease,
        background-color 0.2s ease;
    -o-transition:
        font-size 0.2s ease,
        background-color 0.2s ease;
    -ms-transition:
        font-size 0.2s ease,
        background-color 0.2s ease;
    transition:
        font-size 0.2s ease,
        background-color 0.2s ease;
}
li.orgListItem :hover {
    font-size: 20px;
}

/*******************************************************************
 *
 *
 *  LISTS MENU
 *
 *
 ******************************************************************/
ul.list {
    cursor: pointer;
    cursor: hand;
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 0px;
    text-align: center;
    max-height: 200px;
    overflow-y: scroll;
}
li.listItem {
    cursor: pointer;
    cursor: hand;
    margin: 2px;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 2px;
    border: 1px solid #969696;
    background-color: rgba(150, 150, 150, 0.5);
}
li.listItem a {
    color: #3f464c;
    font-size: 12px;
}
li.listItem i {
    margin: 1px;
    font-size: 18px;
}
li.listItem:hover {
    background-color: rgba(150, 150, 150, 0.7);
}
li.listItem.a:hover {
    background-color: rgba(150, 150, 150, 0.7);
}
.scrollable-menu {
    height: auto;
    max-height: 200px;
    overflow-x: hidden;
}
.addSign button {
    height: 100%;
    padding: 5px;
}

/*******************************************************************
 *
 *
 *  Profiles Page
 *
 *
 ******************************************************************/
ul.profiles-list {
    padding: 0;
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 0px;
    text-align: center;
}
li.profiles-item {
    display: inline-block;
    height: 150px;
    width: 250px;
    cursor: pointer;
    cursor: hand;
    vertical-align: top;
    background: #ccc;
    margin: 2px;
    font-weight: bold;
    border-radius: 2px;
    border: 1px solid #969696;
    background-color: rgba(150, 150, 150, 0.5);
}
ul.profiles-list li:hover {
    background-color: rgba(150, 150, 255, 0.5);
}
li.profile-active {
    background-color: rgba(0, 150, 0, 0.5);
}
li.profile-creator {
    border: 3px solid #ffd700;
}
.profile-active {
    border: 3px solid @blue;
}

/* Drag and drop image target box */
.drop-box-user {
    background: #f5f5f5;
    border: 5px dashed #ddd;
    width: 110px;
    height: 110px;
    text-align: center;
    color: #737373;
}
.drop-box-org {
    background: #f5f5f5;
    border: 5px dashed #ddd;
    width: 170px;
    height: 110px;
    text-align: center;
    color: #737373;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 600px) {
        width: 100%;
        height: 250px;
    }
}
.drop-box-meeting {
    background: #f5f5f5;
    border: 5px dashed #ddd;
    text-align: center;
    margin: 10px;
    color: #737373;
    position: relative;
    cursor: pointer;
}

.attachment :hover {
    background-color: #f5f5f5;
}

.dragover {
    border: 5px dashed #009688;
}
.org-logo-nav-sm {
    padding-left: 10px;
}
.org-logo-nav,
.org-logo-nav-sm {
    height: 36px;
    img {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }
}
.org-logo-card {
    height: 80px;
    width: 80px;
    padding-right: 10px;
    img {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }
}
.org-logo {
    height: 100px;
    width: 160px;
    padding: 5px;

    img {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }

    @media screen and (max-width: 600px) {
        width: 95%;
        height: 95%;

        img {
            width: 100%;
        }
    }
}

#crop-tool {
    display: none;
}
.crop-area {
    border: 1px solid #ddd;
    background: #f5f5f5;
    width: 300px;
    height: 300px;
    margin: 5px;
}
.crop-buttons {
    padding: 5px;
}

/*******************************************************************
 *
 *
 *  Organisation Page
 *
 *
 ******************************************************************/

/* User Page */
.gridStyle {
    position: relative;
    margin-right: 10px;
    width: 100%;
    height: 100%;
}

.disabled {
    color: grey;
    background-color: rgba(150, 150, 150, 0.5) !important;
}

/*******************************************************************
 *
 *
 *  Users
 *
 *
 ******************************************************************/
/* User List */
.users-dropdown-menu {
    max-height: 250px; /*Provide height in pixels or in other units as per your layout*/
    overflow-y: auto; /*Provide an auto overflow to display scroll*/
    a.active {
        background-color: #ddbb66;
    }
}

/*******************************************************************
 *
 *
 *  Org Chart
 *
 *
 ******************************************************************/
.canvas-container {
    position: relative;
}
.positionCanvas {
    background-color: white;

    overflow: hidden;
}
.position-info {
    width: 100%;
    background-color: @mgs_bg_color;
}
.canvas-content {
    margin: 0;
    overflow: hidden;
    position: relative;
}

/*******************************************************************
 *
 *
 *  Terms of Service
 *
 *
 ******************************************************************/
.tos {
    text-align: justify;
    ol {
        list-style-type: none;
        counter-reset: item;
        margin: 0;
        padding: 0;
    }

    ol > li {
        display: table;
        counter-increment: item;
        margin-bottom: 0.6em;
    }

    ol > li:before {
        content: counters(item, ".") ". ";
        display: table-cell;
        padding-right: 0.6em;
    }

    li ol > li {
        margin: 0;
    }

    li ol > li:before {
        content: counters(item, ".") " ";
    }
}

/*******************************************************************
 *
 *
 *  Coach Plan
 *
 *
 ******************************************************************/
.small-chip {
    md-chips.md-default-theme .md-chips,
    md-chips .md-chips {
        box-shadow: none;
    }
    md-chip {
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        md-icon {
            height: 14px;
            width: 14px;
            max-height: 14px;
            max-width: 14px;
            min-height: 14px;
            min-width: 14px;
            top: 35% !important;
        }
    }
}

.clickable-text {
    //background-color: inherit;
    padding: 5px;
    margin: 2px;
}
.clickable-text:hover {
    background-color: lighten(@brand-info, 30%); // Material Teal hue 50
    border-radius: 5px;
}

.small-toolbar {
    margin: 2px;
    padding: 2px;
    .btn-group {
        padding: 0;
        margin: 0;
    }
}

.table.coach-plan > thead > tr > th,
.table.coach-plan > tbody > tr > th,
.table.coach-plan > tfoot > tr > th,
.table.coach-plan > thead > tr > td,
.table.coach-plan > tbody > tr > td,
.table.coach-plan > tfoot > tr > td {
    border-top: none;
}

.md-toolbar-sm {
    min-height: 40px;
    height: 40px;
}

.md-button.md-small {
    min-width: 50px;
}
.md-button.paper-button {
    text-transform: none;
    padding: 0 8px 0 8px;
}

select.mgs-material-select {
    border: 0;
    border-bottom: 1px solid #ccc;
    padding-bottom: 2px;
    background-color: #fff;
}
select.mgs-material-select:focus {
    border-bottom: 2px solid @brand-primary;
}

/*******************************************************************
 *
 *
 *  Help Page
 *
 *
 ******************************************************************/
.docs {
    .article-body img {
        max-width: 100%;
    }
}

/*
 * Other MGS styles
 */

.helptip {
    height: auto;
    font-size: 18px;
    cursor: pointer;
}
.helptip:hover {
    color: @brand-primary;
}

.help-small {
    font-size: 0.9em;
}

.keyvalue {
    padding-right: 20px;
    padding-top: 10px;
    width: 175px;
}

.table.table-pricing {
    color: #455a64;
    th {
        border-bottom: 2px solid #b0bec5 !important;
    }
    td {
        border-bottom: 1px solid #b0bec5 !important;
    }
}

@media screen and (max-width: 767px) {
    .table-responsive {
        border: 1px solid #b0bec5 !important;
    }
}

.simple-border {
    background-color: #fefefe;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 5px;
    padding: 5px;
}

.page-sidenav,
.page-sidenav.md-locked-open-add-active,
.page-sidenav.md-locked-open {
    width: 100%;
    min-width: 35%;
    max-width: 100%;
}

.no-y-scroll {
    overflow-y: hidden !important;
}

.page-sidenav-narrow,
.page-sidenav-narrow.md-locked-open-add-active,
.page-sidenav-narrow.md-locked-open {
    width: 100%;
    min-width: 400px;
    max-width: 100%;
}

.selected {
    background-color: @brand-primary;
    color: white;
}

.selected-secondary {
    background-color: @brand-primary;
    color: white;
}

.scorecard-icon {
    padding: 4px 8px 4px 0px;
}
.scorecard-text {
    padding: 5px;
}
.scorecard-label {
    font-weight: bold;
    padding-bottom: 2px;
}
.scorecard-editable {
    cursor: pointer;
    &:hover {
        background-color: #f1f3f4;
        border-radius: 5px;
    }
}

.org-unit-autocomplete {
    min-height: 150px !important;
}

// Override no data view for nvd3 chart library
.nvd3.nv-noData {
    font-size: 14px;
    font-weight: inherit;
    font-style: italic;
}

.flip-horizontal {
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    filter: FlipH;
    -ms-filter: "FlipH";
}

.header-bordered {
    padding: 2px 5px;
    margin: 4px 5px;
    background-color: white;
    border: 1px solid #aaa;
    border-radius: 5px;
    min-height: 65px;
    min-width: 125px;
}
.meeting-dropdown-revised {
    padding: 6px 10px;
    border: none;
    margin: 0;
    border-radius: 0;
}

.primary-button:hover {
    color: @brand-primary;
}

.number-input-flex {
    text-align: right;
}
.number-input {
    max-width: 120px;
    text-align: right;
}
.number-input-small {
    width: 50px;
    max-width: 50px;
    text-align: right;
}
.number-input-big {
    max-width: 150px;
    text-align: right;
}

.progress-wrapper {
    width: 100%;
    height: 12px;
    text-align: center;
    position: relative;
    overflow: hidden;
    background: rgba(250, 250, 250, 0.5);
}

.progress {
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    background: rgba(100, 100, 100, 0.2);
}

.progress-label {
    position: absolute;
    z-index: 1;
    font-size: 10px;
}

.email-header {
    border-radius: 5px;
    background-color: #f3f5f6;
    border: 1px solid @gray-light;
    padding: 15px;
}

.custom-link {
    cursor: pointer;
    color: @brand-primary;
}

.limit-img img {
    max-width: 95%;
    max-height: 95%;
    height: auto;
    width: auto;
}

.disabled-module {
    background-color: #ffe0e0;
}
.disabled-module-legend {
    background-color: #ffe0e0;
    border: 1px solid #bcbcbc;
    width: 35px;
    height: 35px;
    margin: 5px;
}

.menu-category:hover .menu-hover-button {
    display: block;
}
.menu-hover-button {
    display: none;
    font-size: 18px;
}
.menu-hover-button:hover {
    color: @brand-primary !important;
}

/*******************************************************************
 *
 *
 *  Summary Email dialog
 *
 *
 ******************************************************************/

.summary-email-preview {
    &-good-news p {
        margin-bottom: 0;
    }
}

// Used in material dropdown so that the style of submenu link divs match other menu item buttons
.submenu-button {
    font-size: 15px;
}

.header-dropdown {
    min-height: 50px;
    padding: 2px 12px;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.header-dropdown-left {
    min-height: 50px;
    padding: 2px 12px;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.header-dropdown-right {
    min-height: 50px;
    padding: 2px 12px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.status-colour-toggle {
    border: 1px solid #eceff1;
    border-radius: 5px;
    background-color: #f9f9f9;
    cursor: pointer;
    padding-top: 12px;
}
.status-colour-toggle:hover {
    background-color: #c8ced1;
}
.status-colour-toggle div,
.status-colour-toggle i {
    line-height: 5px;
    height: 5px;
    min-height: 18px;
}

.help-article-menu-item:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.handle-article {
    cursor: move;
    font-size: 1.1em;
}

.tiptop-banner {
    margin-left: 10px;
    margin-right: 10px;

    a {
        text-decoration: none;
    }

    .banner-image {
        max-width: 100%;
        max-height: 40px;
        height: auto;
    }

    .dismiss-button {
        display: none;
    }
}

.tiptop-banner:hover {
    .dismiss-button {
        color: @text-accent-color-lipstick;
        display: inline;
    }
}

.section-details {
    background-color: rgba(187, 222, 251, 0.2);
}
